import { Box } from "@mui/material";
import { identity } from "ramda";
import { FormProvider, useForm } from "react-hook-form";
import { SessionStepCard } from "../SessionStepCard";
import { Controls } from "./Controls";
import { useMsg } from "../../../components/Msg/Msg";
import { actionStepsMessages } from "./ActionSteps";

export const FormStepCard = ({
  step,
  stepper,
  data,
  submitDisabled,
  sx,
  children,
}) => {
  const msg = useMsg({ dict: actionStepsMessages });
  const methods = useForm({
    // mode: "onSubmit", // TODO
    mode: "all",
    defaultValues: data, // TODO: pick(keys, data) vs values: pick(keys, data)
  });
  const isValid = methods.formState.isValid;
  const componentData = Object.fromEntries(
    Object.entries(step.fieldDefMap || {}).map(([name, { map = identity }]) => {
      const value = methods.watch(name);
      try {
        return [name, map(value)];
      } catch (e) {
        console.error("[FormStepCard.rndr] error when mapping field", {
          name,
          value,
          e,
        });
        return [name, value];
      }
    }),
  );

  // console.log("[FormStepCard.rndr] isValid:", isValid, { componentData, data, fieldDefMap, });

  return (
    <FormProvider {...methods}>
      <SessionStepCard {...{ step, stepper, sx }}>
        <Box
          component="form"
          noValidate
          sx={{ mt: 1 }}
          // onSubmit={handleSubmit(submit)}
        >
          {typeof children === "function"
            ? children({ form: methods })
            : children}
          <Controls
            data={componentData}
            handleNext={stepper.handleNext}
            handleBack={stepper.handleBack}
            nextProps={
              stepper.isLast
                ? {
                    disabled: !isValid || submitDisabled,
                    children: msg("action-steps.done"),
                    endIcon: undefined,
                  }
                : {
                    disabled: !isValid || submitDisabled,
                  }
            }
            // sx: { mt: 3 },
          />
        </Box>
      </SessionStepCard>
    </FormProvider>
  );
};
